export let opdHtml = (opdDetails) => {
    let UTCdate = new Date(opdDetails?.registrationDate);
    return `<!DOCTYPE html>
    <html lang="en" xmlns="http://www.w3.org/1999/xhtml">
    <head>
        <meta charset="utf-8" />
        <title></title>
    </head>
    <body>
        <table width="100%">
            <tr>
                <td colspan="4" height="50px"></td>
            </tr>
            <tr>
                <td colspan="4" align="center">
                    <h3>OPD Ticket</h3>
                </td>
            </tr>
            <tr>
                <td width="20%" align="left">
                    <strong>OPD No:</strong>
                </td>
                <td width="30%">
                    <strong>${opdDetails?.opdNumber}</strong>
                </td>
                <td width="10%" align="left">
                    <strong>OPD Date:</strong>
                </td>
                <td width="40%">
                    <strong>${UTCdate?.toLocaleDateString()}</strong>
                </td>
            </tr>
      
            <tr>
                <td width="10%" align="left">
                    <strong>Name:</strong>
                </td>
                <td width="40%">
                    <strong>${opdDetails?.patientName}</strong>
                </td>
                <td width="10%" align="left">
                    <strong>UHID No:</strong>
                </td>
                <td width="40%">
                    <strong>${opdDetails?.emrNumber}</strong>
                </td>
            </tr>
            <tr>
                <td width="10%" align="left">
                    <strong>Age/Sex:</strong>
                </td>
                <td width="40%">
                    <strong>${opdDetails?.age}/${Number(opdDetails?.gender) === 1 ? "M": "F"}</strong>
                </td>
                <td width="10%" align="left">
                    <strong>Doctor:</strong>
                </td>
                <td width="40%">
                    <strong>${opdDetails?.doctorName}</strong>
                </td>
            </tr>
            <tr>
            <td width="10%" align="left">
                <strong>Mobile:</strong>
            </td>
            <td width="40%">
                <strong>${opdDetails?.mobile}</strong>
            </td>
            <td width="10%" align="left">
                <strong>Department:</strong>
            </td>
            <td width="40%">
                <strong>${opdDetails?.departmentName}</strong>
            </td>
        </tr>
    
            <tr>
                <td colspan="4">
                    <hr />
                </td>
            </tr>
        </table>
    </body>
    </html>`
}
